const article = {
    slug: "comme-des-garcons-homme-plus",
    category: "BRAND BUYBACK",
    listTitle: "コムデギャルソンオムプリュス買取",
    listDescription:
      "ランウェイ品、縮絨・再構築・変形テーラードまで、COMME des GARCONS HOMME PLUSのコレクション価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "コムデギャルソンオムプリュス買取｜COMME des GARCONS HOMME PLUSを価値まで査定するEnclopedia",
      description:
        "COMME des GARCONS HOMME PLUS（コムデギャルソンオムプリュス）の買取ならEnclopediaへ。ランウェイ登場品、縮絨・再構築・変形テーラード、近年作から希少アーカイブまで、シーズン背景と需要を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "コムデギャルソンオムプリュス 買取,コムデギャルソン オムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,COMME des GARÇONS HOMME PLUS 買取,オムプリュス 買取,HOMME PLUS 買取,CDG HOMME PLUS 買取,コムデギャルソンオムプリュス 高価買取,コムデギャルソンオムプリュス 宅配買取,コムデギャルソンオムプリュス LINE査定,コムデギャルソンオムプリュス アーカイブ 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/comme-des-garcons-homme-plus",
    },
    hero: {
      label: "COMME DES GARÇONS HOMME PLUS BUYBACK",
      number: "04 / BUYBACK",
      titleLines: [
        "コムデギャルソンオムプリュス買取。",
        "コレクション価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、COMME des GARÇONS HOMME PLUSを、単なるブランド名や型番だけで判断しません。\nランウェイ登場品、シーズンテーマを象徴するデザイン、縮絨・再構築・変形テーラードなど、COMME des GARCONS HOMME PLUSならではの表現を確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "homme plus buyback",
        "runway archive",
        "collection valuation",
        "comme des garçons",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "相場だけではなく、",
        "コレクション文脈まで見る。",
      ],
      image: "media/archive_fashion/buyback4.png",
      imageAlt: "コムデギャルソンオムプリュス買取のメイン画像",
    },
    thesis: {
      text:
        "COMME des GARCONS HOMME PLUSの価値は、ブランド名ではなく、シーズン背景・造形・アーカイブ性まで見て判断する。",
      keywords: ["season", "runway", "archive rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "オムプリュスの価値は、",
        "“ギャルソンのメンズライン”では終わらない。",
      ],
      body:
        "COMME des GARÇONS HOMME PLUSは、川久保玲が手がけるメンズのコレクションラインとして、長年にわたりパリで発表されてきました。\nテーラリングの解体、身体の見え方を変える造形、極端な布量、縮絨や再構築、テーマ性の強いルックなど、COMME des GARCONS HOMME PLUSには通常のメンズウェアとは異なる評価軸があります。\nEnclopediaでは、単に“ギャルソンの服”としてではなく、その一着がどのシーズンに属し、どのような意味を持つかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "シーズン背景とテーマを見る",
          text:
            "COMME des GARCONS HOMME PLUSはコレクションごとのテーマ性が強いラインです。どのシーズンに属し、どの思想や造形が表れているかを確認します。",
        },
        {
          number: "02",
          title: "ランウェイ性と造形を見る",
          text:
            "ランウェイ登場品、テーマを象徴するルック、変形テーラード、立体構造、再構築的なデザインは特に丁寧に評価します。",
        },
        {
          number: "03",
          title: "希少性と現在の需要を見る",
          text:
            "年代、流通量、サイズ、状態、国内外での需要を踏まえ、型番相場だけで終わらせず個別に判断します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "COMME des GARCONS HOMME PLUS全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "ランウェイ登場品・ルック採用品",
          text:
            "コレクションのテーマを強く反映するジャケット、コート、パンツ、セットアップなどを積極的に確認します。",
        },
        {
          tag: "ITEM 02",
          title: "縮絨・再構築・変形テーラード",
          text:
            "COMME des GARCONS HOMME PLUSらしさが明確に表れる加工、歪み、断ち切り、立体的な構造のあるアイテムを丁寧に見ます。",
        },
        {
          tag: "ITEM 03",
          title: "ジャケット・コート・ブルゾン",
          text:
            "テーラードジャケット、ロングコート、ライダース、ブルゾンなど、コレクション性の出やすいアウター類を査定します。",
        },
        {
          tag: "ITEM 04",
          title: "パンツ・サルエル・ワイドシルエット",
          text:
            "COMME des GARCONS HOMME PLUSの造形性が表れやすいパンツ類も対象。布量、シルエット、シーズン性まで見ます。",
        },
        {
          tag: "ITEM 05",
          title: "シャツ・ニット・カットソー",
          text:
            "総柄シャツ、変形シャツ、テーマ性の強いニットやカットソーも、年代や需要を踏まえて査定します。",
        },
        {
          tag: "ITEM 06",
          title: "シューズ・ブーツ・NIKEコラボ",
          text:
            "ブーツ、レザーシューズ、NIKEとのコラボレーションスニーカーなど、需要のあるフットウェアも確認します。",
        },
        {
          tag: "ITEM 07",
          title: "バッグ・バックパック・小物",
          text:
            "リュック、バッグ、アクセサリーなども、COMME des GARCONS HOMME PLUSとしての市場需要に応じて査定対象です。",
        },
        {
          tag: "ITEM 08",
          title: "80s〜近年作までのアーカイブ",
          text:
            "古い年代だから高いとは限りませんが、流通量が少なく、今も評価される作品はアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "COMME des GARCONS HOMME PLUSのアイテム。",
      ],
      intro:
        "査定額は状態や相場で変動しますが、Enclopediaでは特に以下のようなCOMME des GARCONS HOMME PLUSを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "ランウェイ登場品・シーズンを象徴する作品",
          text:
            "特定シーズンのテーマを強く示す柄、装飾、シルエット、セットアップはコレクション性が評価されやすい領域です。",
        },
        {
          index: "02",
          title: "縮絨・再構築・変形などブランド性の強い造形",
          text:
            "一般的なメンズ服では見られない構造性があり、COMME des GARCONS HOMME PLUSらしさが際立つピースは丁寧に査定します。",
        },
        {
          index: "03",
          title: "近年の人気シーズン・需要の強いアウター",
          text:
            "新しいシーズンのコート、ジャケット、ブルゾンなどは、二次流通でも需要が維持されやすく、相場を確認して評価します。",
        },
        {
          index: "04",
          title: "希少アーカイブ・再入手しにくい過去作",
          text:
            "80年代〜2000年代の中でも、今なお評価されるルックや流通の少ない作品は、相場表では拾いきれない価値を見ます。",
        },
        {
          index: "05",
          title: "NIKEコラボ・人気シューズ・ブーツ",
          text:
            "COMME des GARCONS HOMME PLUS名義のコラボレーションやシューズ類も、型番・状態・現在需要に応じて査定します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“メンズ服”としてではなく、",
        "コレクションの一部として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいCOMME des GARCONS HOMME PLUSの価値。",
      ],
      intro:
        "COMME des GARCONS HOMME PLUSは、同じコムデギャルソンでも、評価軸が大きく異なるコレクションラインです。",
      items: [
        {
          index: "01",
          title: "通常のメンズラインと同列に扱わない",
          text:
            "COMME des GARCONS HOMME PLUSはパリコレクションを軸に展開される表現性の高いラインです。HOMMEやHOMME DEUXとは異なる基準で見ます。",
        },
        {
          index: "02",
          title: "型番と状態だけで終わらせない",
          text:
            "品番・コンディションに加え、シーズンテーマ、ルック性、装飾性、海外需要まで確認して判断します。",
        },
        {
          index: "03",
          title: "アーカイブとしての意味を査定に反映する",
          text:
            "Enclopediaはアーカイブのレンタル・共有を行うため、次に着る人へ渡す価値があるかという視点も持って査定します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。COMME des GARCONS HOMME PLUSの年代・品番・ディテールが分かる写真があると、より確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。ご自身の箱または選択制の宅配キットで商品をお送りください。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいCOMME des GARCONS HOMME PLUS買取。",
      ],
      intro:
        "LINEで相談してから進められるため、宅配買取へ進む前に査定可否や方向性を確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、コレクション性の強いアイテムも安心してご相談いただけます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "COMME des GARCONS HOMME PLUS買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "COMME des GARÇONS HOMME PLUSなら、どのようなアイテムを買取していますか？",
          answer:
            "ジャケット、コート、ブルゾン、パンツ、シャツ、ニット、カットソー、ブーツ、スニーカー、バッグ、小物まで幅広くご相談いただけます。",
        },
        {
          question:
            "古いCOMME des GARCONS HOMME PLUSのアーカイブほど高く買い取ってもらえますか？",
          answer:
            "年代だけで一律には判断しません。過去作でもコレクション性・希少性・現在需要が高いものは丁寧に評価します。一方で近年シーズンの人気作が高値になりやすい場合もあります。",
        },
        {
          question:
            "ランウェイ登場品やシーズンを象徴する服は評価されますか？",
          answer:
            "はい。COMME des GARCONS HOMME PLUSはコレクション文脈が重要なラインのため、ランウェイ性やテーマを担うデザインは査定時に確認します。",
        },
        {
          question:
            "縮絨、再構築、変形テーラードなども査定できますか？",
          answer:
            "はい。COMME des GARCONS HOMME PLUSらしさが強く表れる造形や加工は、アイテムの魅力として丁寧に見ます。",
        },
        {
          question:
            "コムデギャルソンオムプリュスの買取相場を先に知りたいです。",
          answer:
            "状態やシーズン、需要によって異なるため、まずはLINEで写真をお送りください。宅配買取へ進む前に、おおまかな方向性をご案内します。",
        },
        {
          question:
            "LINE査定をせずに宅配買取を申し込めますか？",
          answer:
            "申込自体は可能ですが、事前にLINE査定をご利用いただくことで、査定可否や大まかな評価方針を確認しやすくなります。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "COMME des GARCONS HOMME PLUSの価値をご相談ください。",
      ],
      body:
        "ランウェイ品、アーカイブ、縮絨・再構築・変形デザインまで確認。\nEnclopediaが、コレクション価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
